import React from 'react'
import { Button } from 'antd'
import CustomTable from '../../../../elements/Table/CustomTable'
import MoneyCell from '../../../../elements/Table/Cells/MoneyCell'
import UpperCaseCell from '../../../../elements/Table/Cells/UpperCaseCell'

function List (props) {
  const { list, fetch, fetching, isUpdatable, onShow } = props

  const columns = [
    {
      Header: 'SystemID',
      accessor: '_key',
      Cell: ({ value, original }) => <a onClick={() => onShow(original, 'edit')}>{value}</a>,
    },
    { Header: 'Name', accessor: 'name' },
    { Header: 'Category', accessor: 'category', Cell: UpperCaseCell },
    { Header: 'Type', accessor: 'type' },
    { Header: 'Account', accessor: 'account.name' },
    { Header: 'Amount', accessor: 'amount', Cell: MoneyCell },
  ]

  return (
    <CustomTable
      data={list}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      CreateButton={() => (
        <Button
          type={'primary'}
          size="small"
          icon={'plus'}
          onClick={onShow}
          disabled={!isUpdatable}>
          New
        </Button>
      )}
      columns={columns}
    />
  )
}

List.propTypes = {}
List.defaultProps = {}

export default List
